module.exports = __webpack_public_path__ + "img/icon_formEditPlus.158a24f7.svg";